'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _JobsSearchDefaultProps = require('./JobsSearchDefaultProps');

var _JobsSearchDefaultProps2 = _interopRequireDefault(_JobsSearchDefaultProps);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _divider = require('../../divider');

var _divider2 = _interopRequireDefault(_divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'jobs-search';
var JOBS_HOST = 'https://jobsearch.paypal-corp.com/search';

var JobsSearch = function (_React$Component) {
  _inherits(JobsSearch, _React$Component);

  function JobsSearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, JobsSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JobsSearch.__proto__ || Object.getPrototypeOf(JobsSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSticky: false
    }, _this.handleScroll = function () {
      var jobsSectionClientRef = _this.jobsSearchRef.getBoundingClientRect();
      if (jobsSectionClientRef.top <= 0) {
        _this.setState({
          isSticky: true
        });
      } else {
        _this.setState({
          isSticky: false
        });
      }
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      var keywords = encodeURIComponent(e.currentTarget[0].value);
      var country = encodeURIComponent(e.currentTarget[1].value);
      var city = encodeURIComponent(e.currentTarget[2].value);
      var category = encodeURIComponent(e.currentTarget[3].value);

      var finalURL = JOBS_HOST + '?keywords=' + keywords + '&facetcountry=' + country + '&location=' + city + '&facetcategory=' + category;
      document.location.href = finalURL;
    }, _this.renderOptions = function (options) {
      if (options) {
        return options.map(function (elem, idx) {
          var key = '' + elem.value + idx;
          return elem.label && _react2.default.createElement(
            'option',
            {
              key: key,
              value: elem.value
            },
            elem.label
          );
        });
      }
      return null;
    }, _this.renderOptionGroup = function (optionGroup) {
      if (optionGroup) {
        return optionGroup.map(function (elem, idx) {
          var key = '' + elem.value + idx;
          return elem.country && _react2.default.createElement(
            'optgroup',
            {
              key: key,
              label: elem.country,
              'data-country': elem.code
            },
            _this.renderOptions(elem.city)
          );
        });
      }
      return null;
    }, _this.renderPrimaryCta = function (primaryCta) {
      if (primaryCta && primaryCta.text) {
        return _react2.default.createElement(
          _button2.default,
          {
            className: ORGANISM_NAME + '__submit',
            color: 'blue',
            type: 'submit',
            fpti: 'JbSrch-PrmryCTA-' + primaryCta.text
          },
          primaryCta.text
        );
      }
      return null;
    }, _this.renderDropDown = function (list, label) {
      if (list && label) {
        return _react2.default.createElement(
          'select',
          { className: ORGANISM_NAME + '__' + label + ' ' + ORGANISM_NAME + '__dropdown' },
          _this.renderOptions(list.options)
        );
      }
      return null;
    }, _this.renderCityDropdown = function (cities) {
      if (cities && cities.optionGroup && cities.option && cities.option.label) {
        return _react2.default.createElement(
          'select',
          { className: ORGANISM_NAME + '__city ' + ORGANISM_NAME + '__dropdown' },
          _react2.default.createElement(
            'option',
            { value: '' },
            cities.option.label
          ),
          _this.renderOptionGroup(cities.optionGroup)
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /*
    isSticky: make the nav sticy for tablet/desktop,
    it doesn't work for mobile
  */


  _createClass(JobsSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    /*
      this function returns current reference position when
      it reaches top of the organism make the organism sticky
    */


    /*
      render options for country and category
    */


    /*
      render option group for cities
    */


    /*
      render primary cta for search button
    */


    /*
      render general dropdown structure for
      country, city and category
    */


    /*
      render city dropdown structure
    */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$content = this.props.content,
          input = _props$content.input,
          country = _props$content.country,
          cities = _props$content.cities,
          category = _props$content.category,
          primaryCta = _props$content.primaryCta;


      var sectionClasses = (0, _classnames2.default)('' + ORGANISM_NAME, {
        'sticky-form': this.state.isSticky
      });

      return _react2.default.createElement(
        'section',
        {
          'data-building-block': 'organism',
          className: sectionClasses,
          ref: function ref(element) {
            _this2.jobsSearchRef = element;
          }
        },
        _react2.default.createElement(
          'div',
          {
            className: ORGANISM_NAME + '__container container'
          },
          _react2.default.createElement(
            'form',
            {
              className: ORGANISM_NAME + '__form',
              onSubmit: this.handleSubmit,
              onFocus: this.handleFocus,
              onBlur: this.handleBlur,
              action: JOBS_HOST
            },
            _react2.default.createElement('input', {
              className: ORGANISM_NAME + '__keyword',
              name: 'keyword',
              type: 'text',
              placeholder: input.placeHolder,
              ref: function ref(element) {
                _this2.jobsSearchInput = element;
              }
            }),
            this.renderDropDown(country, 'country'),
            this.renderCityDropdown(cities),
            this.renderDropDown(category, 'category'),
            this.renderPrimaryCta(primaryCta)
          )
        ),
        !this.state.isSticky && _react2.default.createElement(_divider2.default, null)
      );
    }
  }]);

  return JobsSearch;
}(_react2.default.Component);

exports.default = JobsSearch;


JobsSearch.propTypes = {
  content: _propTypes2.default.shape({
    input: _propTypes2.default.shape({
      placeHolder: _propTypes2.default.string.isRequired
    }),
    country: _propTypes2.default.shape({
      options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
      }).isRequired).isRequired
    }).isRequired,
    cities: _propTypes2.default.shape({
      option: _propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired
      }).isRequired,
      optionGroup: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        country: _propTypes2.default.string.isRequired,
        code: _propTypes2.default.string.isRequired,
        city: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          value: _propTypes2.default.string.isRequired,
          label: _propTypes2.default.string.isRequired
        }).isRequired).isRequired
      }).isRequired).isRequired
    }).isRequired,
    category: _propTypes2.default.shape({
      options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
      }).isRequired).isRequired
    }).isRequired,
    primaryCta: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  })
};

JobsSearch.defaultProps = _JobsSearchDefaultProps2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/jobs-search/jsx/JobsSearch.js
// module id = 1112
// module chunks = 4